import { useCallback } from "react";
// Hook to handle "Enter" key press to send a message
const useEnterToSend = (onSend: () => void) => {
  return useCallback(
    (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        onSend();
      }
    },
    [onSend]
  );
};

export default useEnterToSend;